import {Avatar, Box} from "@mui/material";

import {retrieveServiceTypeIcon} from "../../helpers/ServiceTypeUtils";

const styles = {
    serviceIconWrap: {
        display: "flex",
        gap: "0.2rem",
        flexWrap: "wrap"
    },
    serviceIcon: {
        width: "1.25rem",
        height: "1.25rem"
    },
    serviceAvatar: {
        width: "1.625rem",
        height: "1.625rem",
        backgroundColor: "white"
    }
};

export default function ServiceTypeIcons({serviceKeycodes}) {
    const uniqueServiceKeycodes = [...new Set(serviceKeycodes || [])];

    if (uniqueServiceKeycodes.length === 0) {
        return null;
    }

    const icons = retrieveServiceTypeIcon(uniqueServiceKeycodes);

    return (
        <Box sx={styles.serviceIconWrap}>
            {icons.map((icon, index) => (
                <Avatar key={`${icon}-${index}`} sx={styles.serviceAvatar}>
                    <Box component="img" src={icon} alt={uniqueServiceKeycodes[index]} sx={styles.serviceIcon}/>
                </Avatar>
            ))}
        </Box>
    );
}